const localization = {
  closeLabel: "Close dialog",
}

export default localization
